// extracted by mini-css-extract-plugin
export default {"button":"OP1WebButtonAppWindow_button__nDCKC","icon":"OP1WebButtonAppWindow_icon__+tcgD","indicator":"OP1WebButtonAppWindow_indicator__ZY+nt"};